// extracted by mini-css-extract-plugin
export default {"content":"style_content__4bHWw","leftSide":"style_leftSide__qAFKQ","rightSide":"style_rightSide__FgL1x","type":"style_type__HPegv"};